
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.webinar__avatar {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  border: 2px solid #fff;
  overflow: hidden;
  position: absolute;
  top: 10px;

  // webinar is limited to 6 speakers in Contentful
  @for $i from 0 through 5 {
    &--#{$i} {
      right: calc(10px + (#{$i} * 20px));
    }
  }
}

@include media-query(tablet) {
  .webinar__avatar {
    width: 44px;
    height: 44px;

    @for $i from 0 through 5 {
      &--#{$i} {
        right: calc(10px + (#{$i} * 30px));
      }
    }
  }
}

// swap corner placement for recorded & scheduled webinar cards
.recorded-webinars,
.scheduled-webinars {
  .webinar__avatar {
    @for $i from 0 through 5 {
      &--#{$i} {
        left: calc(10px + (#{$i} * 20px));
      }
    }
  }

  @include media-query(tablet) {
    .webinar__avatar {
      @for $i from 0 through 5 {
        &--#{$i} {
          left: calc(10px + (#{$i} * 30px));
        }
      }
    }
  }
}
`